import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Navigate, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

// Admin components
import AdminLogin from "@/components/admin/AdminLogin";
import AdminPanel from "@/components/admin/AdminPanel";
import AdminProjectForm from "@/components/admin/AdminProjectForm";
import ProtectedRoute from "@/components/admin/ProtectedRoute";
import CustomCursor from "@/components/CustomCursor";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import HomePage from "@/pages/HomePage";
import SolutionsPage from "@/pages/SolutionsPage";
import PlansPage from "@/pages/PlansPage";
import TechPartnerPage from "@/pages/TechPartnerPage";
import ProjectsPage from "@/pages/ProjectsPage";
import ProjectCasePage from "@/pages/ProjectCasePage";
import InsightsPage from "@/pages/InsightsPage";
import InsightArticlePage from "@/pages/InsightArticlePage";
import NotFoundPage from "@/pages/NotFoundPage";
import ContactPage from "@/pages/ContactPage";
import DiagnosticPage from "@/pages/DiagnosticPage";
import ServicePage from "@/pages/ServicePage";
import LocalServicePage from "@/pages/LocalServicePage";
import { servicePages } from "@/lib/service-pages";
import { localServicePages } from "@/lib/local-service-pages";
import { applyRouteSeo } from "@/lib/route-seo";

const PublicLayout = ({ children }) => (
  <div data-testid="bezierclick-public" className="App">
    <a href="#main-content" className="skip-link">Saltar para o conteúdo</a>
    <CustomCursor />
    <Navbar />
    {children}
    <Footer />
    <ChatWidget />
    <Toaster position="bottom-left" richColors />
  </div>
);

const RouteSeo = () => {
  const location = useLocation();

  useEffect(() => {
    applyRouteSeo(location.pathname);
  }, [location.pathname]);

  return null;
};

function App() {
  return (
    <BrowserRouter>
      <RouteSeo />
      <Routes>
        <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
        <Route path="/solucoes" element={<PublicLayout><SolutionsPage /></PublicLayout>} />
        <Route path="/planos" element={<PublicLayout><PlansPage /></PublicLayout>} />
        <Route path="/tech-partner" element={<PublicLayout><TechPartnerPage /></PublicLayout>} />
        <Route path="/projetos" element={<PublicLayout><ProjectsPage /></PublicLayout>} />
        <Route path="/projetos/:slug" element={<PublicLayout><ProjectCasePage /></PublicLayout>} />
        <Route path="/insights" element={<PublicLayout><InsightsPage /></PublicLayout>} />
        <Route path="/insights/:slug" element={<PublicLayout><InsightArticlePage /></PublicLayout>} />
        <Route path="/contacto" element={<PublicLayout><ContactPage /></PublicLayout>} />
        <Route path="/diagnostico-digital" element={<PublicLayout><DiagnosticPage /></PublicLayout>} />
        {servicePages.map((page) => (
          <Route
            key={page.path}
            path={page.path}
            element={<PublicLayout><ServicePage /></PublicLayout>}
          />
        ))}
        {localServicePages.map((page) => (
          <Route
            key={page.path}
            path={page.path}
            element={<PublicLayout><LocalServicePage /></PublicLayout>}
          />
        ))}
        <Route path="/adm" element={<Navigate to="/admin/login" replace />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminPanel />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/new"
          element={
            <ProtectedRoute>
              <AdminProjectForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/edit/:id"
          element={
            <ProtectedRoute>
              <AdminProjectForm />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<PublicLayout><NotFoundPage /></PublicLayout>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
